/**
 * 404 page — unknown route under the app shell.
 *
 * Per REQ-UI-037 — generic copy; no internal-error details.
 */
import { Link } from "react-router";

export function NotFoundPage(): React.ReactElement {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 text-foreground">
      <p className="text-sm">That page doesn't exist.</p>
      <Link to="/" className="text-body-sm underline text-brand">
        Back to map
      </Link>
    </div>
  );
}
